import { styled, Box } from '@mui/material';

export const OpenCallAccordionLoadingContainer = styled(Box)(({ theme }) => ({
  minHeight: '30vh',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));
